import { FaCity, FaUserFriends } from "react-icons/fa";
import { GiThreeFriends } from "react-icons/gi";
import TrackVisibility from "react-on-screen";
import { HomeTitle } from ".";

const Stat = ({ isVisible, number, title, desc, icon: Icon, delay, color }) => {
	const animation = isVisible
		? `opacity-100 animate-animated animate-zoomIn delay-${delay}`
		: "";
	return (
		<article
			className={`opacity-0 rounded px-4 py-10 bg-primary text-center text-secondary ${animation} ${color}`}
		>
			<div className="flex justify-center">
				<Icon fontSize="60px" />
			</div>
			<h3 className="font-semibold my-4 border-secondary pb-2 text-xl">
				{number} {title}
			</h3>
			<p> {desc} </p>
		</article>
	);
};

const HomeStats = ({ langWords }) => {
	return (
		<section className="container">
			<HomeTitle title={langWords.someNumbers} center />
			<div className=" m-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 my-8">
				<TrackVisibility once>
					<Stat
						number={langWords.wilayaNumber}
						title={langWords.wilaya}
						desc={langWords.wilayaDescripion}
						icon={FaCity}
						delay={0}
						color={"bg-adsilTaxi"}
					/>
				</TrackVisibility>
				<TrackVisibility once>
					<Stat
						number={langWords.partnersNumber}
						title={langWords.partners}
						desc={langWords.partnersDescription}
						icon={GiThreeFriends}
						delay={1}
						color={"bg-adsilVTC"}
					/>
				</TrackVisibility>
				<TrackVisibility once>
					<Stat
						number={langWords.usersNumber}
						title={langWords.users}
						desc={langWords.usersDescription}
						icon={FaUserFriends}
						delay={2}
						color={"bg-adsilVIP"}
					/>
				</TrackVisibility>
			</div>
		</section>
	);
};

export default HomeStats;
